import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    padding: 24,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    boxSizing: "border-box",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 12,
    direction: "rtl",
  },
  entryRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    direction: "rtl",
  },
  card: {
    position: "relative",
    flex: 1,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    border: `1px solid ${theme.palette.divider}`,
    padding: 16,
    boxSizing: "border-box",
    direction: "rtl",
  },
  iconBadge: {
    flexShrink: 0,
    width: 32,
    height: 32,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.common.white,
    border: `1px dashed ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    "& svg": {
      fontSize: "18px !important",
    },
  },
  content: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  headerRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "16px",
    color: theme.palette.secondary.main,
    margin: "-4px 0 4px",
  },
  date: {
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "14px",
    color: theme.palette.text.disabled,
    textAlign: "left",
    margin: 0,
  },
  description: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 13,
    lineHeight: "20px",
    color: theme.palette.text.primary,
  },
  empty: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    color: theme.palette.text.disabled,
    textAlign: "center",
    padding: "24px 0",
  },
}));
